import publishObjectPath from '@/util/configRegistry';
export const toolbarList = [
/*    {
        title:"全国",
        iconFlag:false,
        selectable : false, // 是否可以选中
        selected : false, // 是否选中
        key:"cityList",
        children:[],
    },*/
    // {
    //     title: '街景',
    //     icon: 'icon2',
    //     iconFlag: false,
    //     selectable : false, // 是否可以选中
    //     selected : false, // 是否选中
    //     key: 'streetBar',
    //     children: [
    //         {
    //             title: '百度街景',
    //             key: 'pano-baidu',
    //             selectable : false, // 是否可以选中
    //             selected : false, // 是否选中
    //         },
    //         {
    //             title: '腾讯街景',
    //             key: 'pano-tencent',
    //             selectable : false, // 是否可以选中
    //             selected : false, // 是否选中
    //         },
    //     ],
    // },
    // {
    //     title: '路况',
    //     icon: 'icon3',
    //     iconFlag: false,
    //     selectable : false, // 是否可以选中
    //     selected : false, // 是否选中
    //     key: 'realtime-traffic',
    //     children: [],
    // },

    {
        title: '工具箱',
        icon: 'icon4',
        iconFlag: false,
        selectable : false, // 是否可以选中
        selected : false, // 是否选中
        key: 'toolBox',
        children:
            [{
            title : '距离量测',
            icon : 'tsemapuntitled4',
            selectable : false, // 是否可以选中
            selected : false, // 是否选中
            key: 'measure-distance',
        },
            {
                title : '面积量测',
                icon : 'tsemapuntitled6',
                selectable : false, // 是否可以选中
                selected : false, // 是否选中
                key: 'measure-area',
            },
            // {
            //     title : '标绘',
            //     icon : 'tsemapuntitled',
            //     selectable : false, // 是否可以选中
            //     selected : false, // 是否选中
            //     key: 'plot',
            // },
            // {
            //     title : '专题图',
            //     icon : 'tsemapuntitled10',
            //     selectable : false, // 是否可以选中
            //     selected : false, // 是否有选中状态
            //     key: 'thematic',
            // },
            {
                title : '清屏',
                icon : 'tsemapuntitled7',
                selectable : false, // 是否可以选中
                selected : false, // 是否有选中状态
                key: 'clear',
            },
            {
                title : '截屏',
                icon : 'tsemapuntitled2',
                selectable : false, // 是否可以选中
                selected : false, // 是否有选中状态
                key: 'screen-shot',
            },
            ],
    },


];
// 标绘工具配置
export const plotConfig = {
    // 地图容器唯一标识
    mapId: 'map',
    // 配置文件目录
    configDir: './json/plot/',
    // 图片资源目录
    iconImageDir: './imgs/gisPlot/',
    // 服务配置
    service: {
        RestPlotService: 'NOSQL',
        emapServerUrl: publishObjectPath.value.emapService,
    },
    // 面板样式
    panelStyle: {
        position: 'absolute',
        right: '20px',
        top: '150px',
        display: 'none',
    },

    tabConfig: {
        // 默认
        default: [{
          label: '常用标绘', // 显示名称
          value: 'common', // 唯一标识
        }, {
          label: '应急标绘符号',
          value: 'emergency',
        }, {
          label: '基础标绘符号',
          value: 'basic',
        }, {
          label: '管理标绘',
          value: 'manage',
        }],
        // // 森火
        // 9: [{
        //   label: '常用标绘',
        //   value: 'common',
        // }, {
        //   label: '管理标绘',
        //   value: 'manage',
        // }],
      },
    // 编辑框
    editorStyle: {
        position: 'absolute',
        left: '10px',
        top: '120px',
    },
    textLineLimit: 20,
    // 拖拽参数
    drag: {
        container: '.map-container',
    },
};

